var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://invoice-api.abhyantsolutions.com';
} else {
    service.API_URL = 'https://invoice-api.abhyantsolutions.com';
}

export default service;
